import {
    SAVINGS_PLAN_GET_BEGIN,
    SAVINGS_PLAN_GET_SUCCESS,
    SAVINGS_PLAN_GET_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function getSavingsPlan(savingsPlanId) {
    return async dispatch => {
        dispatch({
            type: SAVINGS_PLAN_GET_BEGIN
        })

        try {
            const plan = await BFFAgent.SavingsPlan.getSavingsPlan(savingsPlanId)
            const datamaster = await BFFAgent.Datamasters.getAuto(plan.datamaster_id)

            dispatch({
                type: SAVINGS_PLAN_GET_SUCCESS,
                data: {
                    brand: datamaster.brand,
                    model: datamaster.model,
                    version: datamaster.version,
                    ...plan
                }

            })
        } catch (error) {
            dispatch({
                type: SAVINGS_PLAN_GET_FAILURE,
                data: {
                    error:
                        error?.data?.message ||
                        error.message ||
                        'Error al obtener el plan de ahorro'
                }
            })
        }
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case SAVINGS_PLAN_GET_BEGIN:
            return {
                ...state,
                savingsPlanPending: true,
                savingsPlanSuccess: false,
                savingsPlanError: false
            }

        case SAVINGS_PLAN_GET_SUCCESS:
        return {
                ...state,
                savingsPlan: action.data,
                savingsPlanPending: false,
                savingsPlanSuccess: true,
                savingsPlanError: false
            }

        case SAVINGS_PLAN_GET_FAILURE:
            return {
                ...state,
                savingsPlan: null,
                savingsPlanPending: false,
                savingsPlanSuccess: false,
                savingsPlanError: true
            }

        default:
            return state
    }
}
